import React from 'react'
import { useState } from 'react'

import {
  Card,
  Col,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from '@themesberg/react-bootstrap'

import { Wrapper } from './ProdcutOwnerDetailsTab.styled'
import { FormattedMessage } from 'react-intl'
import { DataTransform } from '../../../../lib/sharedFun/Time'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { AiFillCopy, AiFillEdit } from 'react-icons/ai'
import { useDispatch, useSelector } from 'react-redux'
import { ProductTrialType, PublishStatus } from '../../../../const/product'
import { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import useRequest from '../../../../axios/apis/useRequest'
import { setAllPlans } from '../../../../store/slices/products/productsSlice'
import Label from '../../Shared/label/Label'
import DescriptionCell from '../../Shared/DescriptionCell/DescriptionCell'
import BreadcrumbComponent from '../../Shared/Breadcrumb/Breadcrumb'
import { BsBoxSeam, BsFillTrash3Fill } from 'react-icons/bs'
import UpperContent from '../../Shared/UpperContent/UpperContent'
import DynamicButtons from '../../Shared/DynamicButtons/DynamicButtons'
import {
  MdOutlinePublishedWithChanges,
  MdOutlineUnpublished,
} from 'react-icons/md'
import { TabPanel, TabView } from 'primereact/tabview'
import {
  productOwnerChangeAttr,
  productOwnerInfo,
  removeProductOwnerStore,
} from '../../../../store/slices/productsOwners'
import { Routes } from '../../../../routes'
import { object } from 'yup'
import { update } from 'lodash'
import ProductOwnerLimitsTab from '../ProductOwnerLimitsTab/ProductOwnerLimitsTab'
import SafeFormatMessage from '../../Shared/SafeFormatMessage/SafeFormatMessage'
import DataLabelWhite from '../../Shared/DateLabelWhite/DateLabelWhite'

const ProductOwnerDetails = () => {
  const routeParams = useParams()
  const [visible, setVisible] = useState(false)
  const dispatch = useDispatch()
  const [activeIndex, setActiveIndex] = useState(0)
  const [update, setUpdate] = useState(0)
  useEffect(() => {
    setActiveIndex(0)
  }, [routeParams.id])

  const {
    getProductOwner,
    deleteProductOwnerReq,
    GetCurrentProductOwnerByUserId,
  } = useRequest()
  useEffect(() => {
    if (userRole != 'clientAdmin') {
      return
    }
    ;(async () => {
      const productOwnerData = await GetCurrentProductOwnerByUserId()
      dispatch(
        productOwnerInfo({
          id: routeParams.id,
          data: productOwnerData.data.data,
        })
      )
    })()
  }, [visible, routeParams?.id])
  let userInfo = useSelector((state) => state.auth.userInfo)

  let userRole = userInfo.userType
  const navigate = useNavigate()
  let location = useLocation()

  const pathIncludesInfo = location?.pathname.includes('info')
  const current = pathIncludesInfo
    ? userInfo.ProductOwnerInfo?.id
    : routeParams.id
  useEffect(() => {
    if (userRole == 'clientAdmin') {
      return
    }
    ;(async () => {
      const productOwnerData = await getProductOwner(routeParams.id)
      dispatch(
        productOwnerInfo({
          id: routeParams.id,
          data: productOwnerData.data.data,
        })
      )
    })()
  }, [visible, routeParams?.id, update])

  const listData = useSelector((state) => state.productsOwners.productsOwners)
  let productOwner = listData?.[routeParams.id]
  const deleteProductOwner = async () => {
    await deleteProductOwnerReq(current)
    dispatch(removeProductOwnerStore(current))
  }
  const handleProductClick = (productId) => {
    navigate(`${Routes.products.path}/${productId}`)
  }

  return (
    <Wrapper>
      {productOwner && (
        <BreadcrumbComponent
          breadcrumbInfo={'ProductsOwnersDetails'}
          param1={productOwner.id}
          icon={BsBoxSeam}
          data={{ name: productOwner.ownerName }}
        />
      )}

      {productOwner && (
        <div className="main-container">
          <UpperContent>
            <h4 className="m-0">
              <SafeFormatMessage id="Product-Owner-Details" /> :{' '}
              {productOwner.systemName}{' '}
            </h4>
            <DynamicButtons
              buttons={[
                {
                  order: 2,
                  type: 'form',
                  id: routeParams.id,
                  label: 'Edit',
                  component: 'editProductOwner',
                  icon: <AiFillEdit />,
                  setActiveIndex: setActiveIndex,
                  update: update,
                  setUpdate: setUpdate,
                },
                // {
                //   order: 5,
                //   type: 'delete',
                //   confirmationMessage:
                //     'delete-product-owner-confirmation-message',
                //   id: routeParams.id,
                //   navAfterDelete: Routes.productsOwners.path,
                //   label: 'Delete-Product-Owner',
                //   request: deleteProductOwner,
                //   icon: <BsFillTrash3Fill />,
                // },
              ]}
            />
          </UpperContent>

          {productOwner && (
            <TabView
              scrollable
              className="card"
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header={<SafeFormatMessage id="Details" />}>
                <div className="row-button">
                  <div className="dynamicButtons"></div>
                </div>
                <Card border="light" className="shadow-sm border-0">
                  <Card.Body className="p-0">
                    <Table
                      responsive
                      className="table-centered table-nowrap rounded mb-0"
                    >
                      <tbody>
                        <tr>
                          <td className="fw-bold line-cell">
                            <SafeFormatMessage id="Display-Name" />
                          </td>
                          <td className="line-cell">
                            {productOwner.displayName}
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-bold">
                            <SafeFormatMessage id="System-Name" />
                          </td>
                          <td>{productOwner.systemName}</td>
                        </tr>
                        <tr>
                          <td className="fw-bold">
                            <SafeFormatMessage id="Products" />
                          </td>
                          <td>
                            {productOwner.products &&
                              Object.values(productOwner.products) &&
                              Object.values(productOwner.products).map(
                                (product, index) => (
                                  <span
                                    className="mx-1"
                                    key={index}
                                    onClick={() =>
                                      handleProductClick(product.id)
                                    }
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <DataLabelWhite text={product.systemName} />
                                  </span>
                                )
                              )}
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-bold">
                            <SafeFormatMessage id="Created-Date" />
                          </td>
                          <td>{DataTransform(productOwner.createdDate)}</td>
                        </tr>
                        <tr>
                          <td className="fw-bold">
                            <SafeFormatMessage id="Last-Updated-Date" />
                          </td>
                          <td>{DataTransform(productOwner.editedDate)}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </TabPanel>
              <TabPanel
                header={<SafeFormatMessage id="Product-Owner-Limits" />}
              >
                <ProductOwnerLimitsTab productOwnerId={productOwner.id} />
              </TabPanel>
            </TabView>
          )}
        </div>
      )}
    </Wrapper>
  )
}
export default ProductOwnerDetails
